import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ErrorDialogComponent } from '@shared/components/error-dialog/error-dialog.component';

export interface ErrorDialogData {
  title?: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ErrorDialogService {
  private readonly translateService = inject(TranslateService);
  private readonly dialogService = inject(DialogService);

  showError(message: string, title = this.translateService.instant('common.messages.error')): DynamicDialogRef {
    return this.dialogService.open(ErrorDialogComponent, {
      header: title,
      inputValues: { message },
      width: '500px',
      modal: true,
      draggable: false,
      resizable: false,
      dismissableMask: true,
      closable: true,
    });
  }
}
